import { useEffect } from "react";
import ScrollMagic from "scrollmagic";
import ShopifyHeroSection from "./ShopifyHeroSection";
import ShopifyContent from "./ShopifyContent";
import FoodrnaContactUs from "../Foodarna/FoodrnaContactUs/FoodrnaContactUs";
import ShopifyFeature from "./ShopifyFeature";
import honeyCombBg from "../../Images/Owision/honeyCombBg.png";
import { Helmet } from "react-helmet-async";

const ShopifyStripe = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  return (
    <>
      <Helmet>
        <title> Owision | Shopify Stripe Integration- Secure Payments</title>
        <meta
          name="description"
          content="Learn about Owision’s secure Shopify-Stripe integration — seamless payment processing, enhanced PCI compliance & smooth checkout experience for your store.
"
        />
      </Helmet>
      <div style={{ overflowX: "hidden" }}>
        <div
          id="triggerPinned"
          className="bg-white"
          style={{
            backgroundImage: `url(${honeyCombBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <ShopifyHeroSection />
        </div>
        <section
          className="project-detail !mt-0 md:!mt-[3rem]"
          style={{
            zIndex: "1",
          }}
        >
          <ShopifyContent />
        </section>
        <section
          className="foodrna-footer-section"
          style={{
            zIndex: "1",
            color: "black",
          }}
        >
          <ShopifyFeature />
          <FoodrnaContactUs />
        </section>
      </div>
    </>
  );
};

export default ShopifyStripe;
